'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';

interface CommonDynamicIntroductionProps {
  heading: string;
  description?: string;
  className?: string;
  headingClassName?: string;
  backgroundImage?: string;
}

export default function CommonDynamicIntroduction({
  heading,
  description,
  className,
  headingClassName,
  backgroundImage,
}: CommonDynamicIntroductionProps) {
  return (
    <Stack
      component="section"
      className={`${cn.westminsterCommonIntroduction} ${className}`}
    >
      <Box
        className={cn.westminsterIntroductionInner}
        sx={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
        }}
      >
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.westminsterIntroductionContent}>
            <Box
              className={`${cn.introductionContentHeading} ${headingClassName}`}
            >
              <ParallaxText
                variant="h2"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(heading)}
              </ParallaxText>
            </Box>
            {description ? (
              <Box className={cn.introductionContentData}>
                <ParallaxText
                  variant="p"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(description)}
                </ParallaxText>
              </Box>
            ) : (
              <></>
            )}
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
